<div class="dialog-container">
  <h2 mat-dialog-title>
    <div class="title-content">
      <mat-icon>inventory_2</mat-icon>
      <span>Related Stocks for {{ email }}</span>
    </div>
  </h2>

  <mat-dialog-content>
    @if (loading) {
      <div class="loading-spinner">
        <mat-spinner></mat-spinner>
        <p>Loading stocks...</p>
      </div>
    } @else {
      @if (stocks.length > 0) {
        <div class="stocks-count">
          <mat-icon>info</mat-icon>
          <span>Found {{ stocks.length }} stock(s) for this email</span>
        </div>

        <div class="table-wrapper">
          <table mat-table [dataSource]="stocks" class="stocks-table">

            <ng-container matColumnDef="supplier">
              <th mat-header-cell *matHeaderCellDef>Supplier</th>
              <td mat-cell *matCellDef="let stock">{{ stock.supplier }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let stock">
                <mat-chip [class]="getStatusClass(stock.status)">
                  {{ stock.status }}
                </mat-chip>
              </td>
            </ng-container>

            <ng-container matColumnDef="remained_coins">
              <th mat-header-cell *matHeaderCellDef>Remained Coins</th>
              <td mat-cell *matCellDef="let stock">
                {{ stock.remained_coins | number }}
              </td>
            </ng-container>

            <ng-container matColumnDef="coins_to_be_remain">
              <th mat-header-cell *matHeaderCellDef>Stop threshold</th>
              <td mat-cell *matCellDef="let stock">{{ stock.coins_to_be_remain | number }}</td>
            </ng-container>

            <ng-container matColumnDef="updated_at">
              <th mat-header-cell *matHeaderCellDef>Updated</th>
              <td mat-cell *matCellDef="let stock">{{ stock.updated_at | date:'short' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      } @else {
        <div class="no-data">
          <mat-icon>inventory_2</mat-icon>
          <p>No stocks found for this email</p>
          <p class="subtitle">This login info has not been imported to stocks yet</p>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="close()">
      Close
    </button>
  </mat-dialog-actions>
</div>
